import ModalActions from 'components/modals/components/modal-actions';
import ModalContent from 'components/modals/components/modal-content';
import ModalTitle from 'components/modals/components/modal-title';
import SCModal from 'components/modals/sc-modal';
import SCButton from 'components/sc-button';
import globalMessages from 'intl/global-messages';
import noop from 'lodash/noop';
import React from 'react';
import {useIntl} from 'react-intl';

import type {Props as ModalContentProps} from './components/modal-content';
import type {Props as ModalTitleProps} from './components/modal-title';
import type {Props as DialogModalProps} from './sc-modal';

type Props = Pick<DialogModalProps, 'open' | 'onClose' | 'onExited' | 'size'> &
    Pick<ModalContentProps, 'children'> & {
        modalTitle: ModalTitleProps['title'];
    };

const AcknowledgementModal = (props: Props) => {
    const {modalTitle, open, onClose, onExited = noop, size = 'medium', children} = props;
    const {formatMessage} = useIntl();

    return (
        <SCModal open={open} size={size} onClose={onClose} onExited={onExited}>
            <ModalTitle title={modalTitle} />
            <ModalContent>{children}</ModalContent>
            <ModalActions>
                <SCButton
                    variant='secondary'
                    onClick={onClose}
                    label={formatMessage(globalMessages.close)}
                    disabled={false}
                    inProgress={false}
                />
            </ModalActions>
        </SCModal>
    );
};

export default AcknowledgementModal;
